
export default function WhyBuildToLead() {
  const reasons = [
    {
      icon: 'ri-focus-3-line',
      title: 'Built for Extension Companies',
      description:
        'We specialise in house extensions and loft conversions. Our ads, messaging, and follow-up are tailored specifically for this market.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Proven Process',
      description:
        'Built around what actually causes enquiries to convert: fast response times, structured follow-up, and clear tracking. Our system is designed using best practices from high-performing service businesses.',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Response Times',
      description:
        'Speed matters. Our system ensures enquiries are handled immediately, so you\'re always first in line to speak with homeowners.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'No Long-Term Contracts',
      description:
        "We're confident in our service. That's why we don't lock you into lengthy contracts. Stay because it works, not because you have to.",
    },
  ];

  return (
    <section id="why-us" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-[#1a2947] mb-6">
            Why <span className="text-[#2B5797]">Build to Lead</span>
          </h2>
          <p className="text-xl text-[#334155] max-w-3xl mx-auto leading-relaxed">
            We understand the challenges extension companies face. Here's why builders choose to work with us:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-[#F8FAFC] rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#4A6FA5] rounded-full mx-auto mb-6 shadow-md">
                <i className={`${reason.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#334155] mb-4">{reason.title}</h3>
              <p className="text-lg text-[#334155]/70 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
